<template>
  <button class="create-gift-button" @click="onClick">
    <CreateGiftWhite class="create-gift-button__icon" />
    <span class="create-gift-button__text subhead-bold">ギフト作成</span>
  </button>
</template>

<script>
import CreateGiftWhite from '../../atoms/svg_icons/CreateGiftWhite'
export default {
  components: { CreateGiftWhite },
  methods: {
    onClick() {
      this.$emit('click-button')
    }
  }
}
</script>

<style lang="scss" scoped>
.create-gift-button {
  @extend %hover-common;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background-color: $primary;
  cursor: pointer;

  &__icon {
    margin-bottom: 10px;
  }

  &__text {
    font-size: 1.4rem;
    color: $white;
  }
}
</style>
